import React, { ReactElement } from 'react'
import Select from 'react-select'
import useLookup from '../hooks/useLookup'
import useDashboard from '../hooks/useDashboard'
import loadPreferedObject from '../hooks/loadPreferredObject'
import loadObjects from '../hooks/loadObjects'
import useAssets from '../hooks/useAssets'
import useWellId from '../hooks/useWellId'

export default function ({ label, objectType }): ReactElement | null {
    const { dashboardId, editMode, reload } = useDashboard()
    const [lookupAsset] = useLookup()
    const [assets] = useAssets()

    const well = useWellId(lookupAsset, assets)
    const asset = objectType === 'trajectory' ? well?.extensionId : lookupAsset

    const objects = loadObjects({ asset, objectType })
    const [current, setCurrent] = loadPreferedObject(objects, { asset, objectType, dashboardId, editMode })

    if (!asset) {
        return null
    }

    function selectObject(object): void {
        setCurrent(object.uid)
        fetch(`/services/plugin-drilling-widgets/objects/${asset}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                dashboardId,
                uid: object.uid,
                object: object.object,
                editMode
            })
        }).then(() => {
            reload(objectType)
        })
    }

    return (
        <div>
            <label className="control-label">{label}</label>
            <Select
                clearable={false}
                labelKey={'name'}
                options={objects}
                onChange={selectObject}
                value={objects.find(obj => obj.uid === current)}
            />
        </div>
    )
}
